import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { setAddInitiateIVToTimeline } from '../store/quickActions.actions'
import { resetState } from '../../procedures/initiateIv/store/initiateIv.actions'
import { addInitiateIvItem } from '../../timeline/store/timeline.actions'
import { InitiateIvConstants } from '../../procedures/initiateIv/store/initiateIv.constants'

export function* saveInitiateIvQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addInitiateIVToTimeline } = quickActionsObject
  if (addInitiateIVToTimeline) {
    yield put(addInitiateIvItem())
    yield put(setAddInitiateIVToTimeline(false))
    yield put(resetState())
  }
}

export function* saveInitiateIvQuickActionTimeLineRowSaga() {
  yield takeLatest([InitiateIvConstants.SET_ADD_TO_TIMELINE], saveInitiateIvQuickActionTimeLineRow)
}
